'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatNumber = exports.generateRandomString = exports.uniformError = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _sprintfJs = require('sprintf-js');

var _uiTranslations = require('@wh/ui-translations');

var _constants = require('../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Returns a translation provider object
 * @returns {Function} translation provider t function
 */
var getTranslationProvider = function getTranslationProvider() {
  return (0, _uiTranslations.createTranslator)();
};

/**
 * Returns the translation for the API error.
 * If the translation token is found in translations, then override the OB translation
 * otherwise use the OB provided translation.
 * Empty string is returned if no translations have been found.
 *
 * @param {Object} error  the error object
 * @returns {string} an array of translated errors
 */
var getTranslatedError = function getTranslatedError(error) {
  if (!error) {
    return '';
  }

  var t = getTranslationProvider();
  var translatedErrorCode = t(_constants.TRANSLATION_CONTEXT)(error.code);

  if (translatedErrorCode !== _constants.TRANSLATION_CONTEXT + ':' + error.code) {
    if (error.type === 'variable_token') {
      return (0, _sprintfJs.vsprintf)(translatedErrorCode, error.errorArgs);
    }

    return translatedErrorCode;
  }

  if (error.xlation) {
    if (error.type === 'variable_token') {
      return (0, _sprintfJs.vsprintf)(error.xlation, error.errorArgs);
    }

    return error.xlation;
  }

  return '';
};

/**
 * Uniforms the error messages
 *
 * @param {Object} error a generic error object returned by the PMT api
 * @returns {Object} an error object with a standard structure
 */
var uniformError = exports.uniformError = function uniformError(error) {
  /**
   * [processAPIError description]
   * @param  {[type]} apiError [description]
   * @return {[type]}          [description]
   */
  var processAPIError = function processAPIError(apiError) {
    return {
      code: apiError.code || _constants.QD_GENERIC_ERROR_CODE,
      message: apiError.xlation ? getTranslatedError(apiError) : _constants.QD_GENERIC_ERROR_MESSAGE,
      payload: (0, _extends3.default)({}, apiError.errorArgs)
    };
  };

  /**
   * [processInternalError description]
   * @param  {[type]} internalError [description]
   * @param  {[type]} t             [description]
   * @return {[type]}               [description]
   */
  var processInternalError = function processInternalError(internalError, t) {
    return {
      code: internalError,
      message: t(_constants.TRANSLATION_CONTEXT)(internalError) !== _constants.TRANSLATION_CONTEXT + ':' + internalError ? t(_constants.TRANSLATION_CONTEXT)(internalError) : _constants.QD_GENERIC_ERROR_MESSAGE,
      payload: (0, _extends3.default)({}, internalError.errorArgs)
    };
  };

  // default generic error
  var errorObj = {
    code: _constants.QD_GENERIC_ERROR_CODE,
    message: _constants.QD_GENERIC_ERROR_MESSAGE,
    payload: {}
  };

  //Pmt API error object
  if (error.elements && error.elements.length) {
    return processAPIError(error.elements[0] || {});
  }

  //Internal token error
  if (typeof error === 'string') {
    var t = getTranslationProvider();
    return processInternalError(error, t);
  }

  return errorObj;
};

/**
 * method to create random string of variable length
 * @param {number} chars The number of characters
 * @returns {String} the generated string
 * @public
 */
var generateRandomString = exports.generateRandomString = function generateRandomString(chars) {
  var source = 'abcdefghijklmnopqrstuwxyz0123456789';
  var randomString = '';

  /**
   * Generate a random number between pMin and pMax
   * @param {number} pMin low limit
   * @param {number} pMax high limit
   * @returns {number} the random number
   * @private
   */
  var getRandomNumber = function getRandomNumber(pMin, pMax) {
    var min = Math.ceil(pMin);
    var max = Math.floor(pMax);
    var diff = max - min; //eslint complains about no-mixed-operators caused by prettier removing parentheses

    return Math.floor(Math.random() * (diff + 1)) + min;
  };

  for (var i = 0; i < chars; i++) {
    randomString += source[getRandomNumber(0, source.length - 1)];
  }

  return randomString;
};

/**
 * Given a string and an integer specifing the number of decimal values,
 * this function returns a string reppresenting the number with the specified
 * number of digits.
 *
 * @param {string} value the string to format
 * @param {number} decimals the number of decimals
 * @returns {string} the formatted string
 */
var formatNumber = exports.formatNumber = function formatNumber(value, decimals) {
  var parsedValue = parseFloat(Math.round(value.replace(/,/g, '.') * 100) / 100).toFixed(decimals);

  return parsedValue === 'NaN' || parsedValue === 0 ? value || '' : parsedValue;
};